import React, { useEffect, useRef, useState } from "react";
import "./detail.css";
import { useNavigate, useParams } from "react-router-dom";
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { CourseContentModuleRowComponent } from "../../components/ModuleContentRowComponent/index-v2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useMoodleV2 } from "../../contexts/moodle";
import { Navbar } from "../../components/Navbar";
import { useAuth } from "../../contexts/AuthContext";
import { getUserNru } from "../../services/tipddy/nru";
import { defaultSenceValidation } from "../../utils/handler";
import { SenceValidation } from "../../services/sence";
import { FormSence } from "../../services/sence/form";
import { useTimer } from "../../components/Timer";
import { CustomDialog } from "../../components/Dialog";
import { LIMIT_CRON_DIALOG } from "../../utils/state";
import { CustomSpinner } from "../../components/Loader/custom.spinner";
import { useTheme } from "../../contexts/ThemeContext";
import groupIcon from "../../assets/grupo-gris.png";
import { readableColor, transparentize } from "polished";
import flechaBlanca from "../../assets/decidido/flecha_blanca.png";
import { useConfig } from "../../contexts/config";
import useActivityCompleted from "../../hooks/useActivityCompleted";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './index.css'
// import { local } from "d3";

export const DetailCourseV2 = () => {
  const auth = useAuth();
  const { lang } = useAuth();
  const params = useParams();
  const { config } = useConfig();
  const moodlev2 = useMoodleV2();
  const theme = useTheme();
  const navigate = useNavigate();
  // const [refresh, setRefresh] = useState(0);
  const [layout, setLayout] = useState(true);
  const [loading, setLoading] = useState(true);
  const [messageReady, setMessageReady] = useState(false);
  const [group, setGroup] = useState(null);
  const [message, setMessage] = React.useState({
    open: false,
    title: "",
    message: "",
    isBeforeunload: true,
  });
  const [isMobile, setIsMobile] = useState(false);
  const [navigating, setNavigating] = useState(0);
  const { limit } = useTimer();
  const { activityCompletedButtonClicked } = useActivityCompleted(null);
  const contentFixedBar = document.getElementById("content-fixed-bar")

  // const fetchCurrentCourseProgress = async () => {
  //   const data = await moodlev2.getCourseProgressPercentage(params.id);
  //   data ? setRefresh(refresh + 1) : setRefresh(refresh);
  //   console.log(refresh, data);
  //   localStorage.setItem("courseProgress", data);
  //   return data;
  // };

  // useEffect(() => {
  //   fetchCurrentCourseProgress();
  //   //eslint-disable-next-line
  // }, []);

  /*   useEffect(() => {
      lang && console.log(lang["Coursedetail"]);
    }, [lang]);
   */
  useEffect(() => {
    moodlev2.getCourseUserList(params.id).then((res) => {
      //console.log("group: ", res);
      setGroup(res);
    });

    const checkMobile = () => {
      const ua = navigator.userAgent;
      const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
      setIsMobile(iOS || isMobileDevice);
    };
    checkMobile();
    //eslint-disable-next-line
  }, [params.id]);

  useEffect(() => {
    // window.scrollTo(0, 0);
    // let course_progress = JSON.parse(localStorage.getItem("courseProgress"));
    if (params.id === undefined) {
      navigate("/listcourses");
    } else {
      // let course_progress = fetchCurrentCourseProgress();
      // if (+course_progress < 1) {

      moodlev2
        .getCourseContentByID(params.id, true, window.location.search)
        .catch((err) => {
          console.error("Error loading course content:", err);
          navigate("/listcourses");
        });
      // } else if (+course_progress >= 1) {
      //   moodlev2
      //     .getCourseContentByID(params.id, false, window.location.search, true)
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // }
    }
    // eslint-disable-next-line
  }, []);

  async function fetchNRU() {
    // console.log({ userData: auth.user });
    //console.log(config);
    let args = {
      courseid: moodlev2.currentCourse.id,
      userid: auth.user.id,
      username: auth.user.username
    };
    return Promise.resolve(await getUserNru(args));
  }

  function isSenceRequired(isSence, nru) {
    let required = false;
    let session = localStorage.getItem("sence_session");
    if (isSence && nru && !session) {
      required = true;
    }
    return required;
  }

  async function VerifySence() {
    console.log(moodlev2.currentCourse);
    let data = defaultSenceValidation(moodlev2.currentCourse);
    console.log({ defaultSenceValidation: data.isSence });
    if (data.isSence) {
      let nru = null;
      let rawNru = await fetchNRU(); // descomentado para no forzar el flujo sence
      console.log({ rawNru });
      /* let rawNru = [{ rnu: "123456" }]; */
      if (rawNru && rawNru.length > 0) {
        nru = rawNru[0].rnu;
        localStorage.setItem("nru", nru);
      }
      let isRequired = isSenceRequired(data.isSence, nru);
      console.log({ isSenceRequired: isRequired });
      if (isRequired) {
        let validation = {
          idSence: data.idSence,
          auth,
          session: null,
          isLogin: true,
          nru,
        };
        localStorage.setItem("idSence", data.idSence);
        localStorage.setItem("current_course", params.id);
        /* console.log(auth);
        console.log(validation); */
        return SenceValidation(validation);
      } else {
        return setLoading(false);
      }
    } else {
      return setLoading(false);
    }
  }

  React.useEffect(() => {
    if (
      moodlev2.currentCourse &&
      localStorage.getItem("last_login_sence" && !messageReady)
    ) {
      window.onbeforeunload = function (e) {
        e = e || window.event;
        if (e) {
          e.returnValue = "Sure?";
        }
        return "Sure?";
      };
      setMessageReady(true);
      setMessage({
        ...message,
        open: true,
        title: "Bienvenido a su curso Sence",
        message:
          "No olvides cerrar sesión Sence al finalizar, cuando queden 10 segundos de sesión se redireccionará automáticamente a Sence para cerrar su sesión",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moodlev2.currentCourse]);

  React.useEffect(() => {
    if (
      localStorage.getItem("last_login_sence") &&
      limit > LIMIT_CRON_DIALOG &&
      message.isBeforeunload
    ) {
      window.onbeforeunload = function (e) {
        return null;
      };
      setMessage({
        ...message,
        open: true,
        title: "Quedan 2 minutos para cerrar sesión",
        message:
          "Si desea cerrar sesión manualmente, haga click en cerrar Sence o espere 2 minutos",
        isBeforeunload: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  React.useEffect(() => {
    if (moodlev2.currentCourse) {
      console.log("VerifySence");
      VerifySence();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moodlev2.currentCourse]);

  function handleContentLayout() {
    setLayout(!layout);
  }

  return (
    <>
      {lang && (
        <>
          {loading && <CustomSpinner />}
          <FormSence />
          <Navbar layout={layout} handleContentLayout={handleContentLayout} />
          <DetailCourseWrapper>
            <CoreVisualContent
              moodlev2={moodlev2}
              token={auth.user.token}
              layout={layout}
              handleContentLayout={handleContentLayout}
              lang={lang}
              setNavigating={setNavigating}
            />
            <CourseContentContainer
              handleContentLayout={handleContentLayout}
              layout={layout}
            >
              <div id="content-fixed-bar" className="sticky top-[-1px] z-50 pt-2 pb-2 bg-white" style={{ backgroundColor: theme.mode === 'dark' ? 'var(--detail-course-bg)' : '#ffffff' }}>

                <CourseTitle moodleV2={moodlev2} params={params} />
                <TabsRow lang={lang} />
              </div>
              {/* <DiagnosticEvaluationButton /> */}
              {group && <GroupRow group={group} />}
              <ContentPickerContainer>
                {moodlev2.currentModules &&
                  moodlev2.currentModules.map((module, idx) => {
                    // Ocultar módulo específico
                    if (module.name === "Tema 1") return null;

                    // Curso sin sesiones en línea
                    if (
                      module.modules[0]?.name ===
                      "Este curso no posee sesiones en línea"
                    ) {
                      return (
                        <div key={idx}>
                          <p
                            style={{
                              color: readableColor(
                                theme.colors.backgroundColorDetailCourse
                              ),
                            }}
                          >
                            Este curso no posee sesiones en línea
                          </p>
                        </div>
                      );
                    }

                    // Módulo "Programas" vacío
                    if (
                      module.name &&
                      module.name === "Programas" &&
                      module.modules.length === 0
                    ) {
                      return (
                        <div key={idx}>
                          <p
                            style={{
                              color: readableColor(
                                theme.colors.backgroundColorDetailCourse
                              ),
                            }}
                          >
                            Este curso no posee programas
                          </p>
                        </div>
                      );
                    }
                    return (
                      <CourseContentModuleRowComponent
                        module={module}
                        key={`${moodlev2.selectedView}-${module.id}`}
                        moodle={moodlev2}
                        idx={idx}
                        navigating={navigating}
                        contentFixedBar={contentFixedBar?.scrollHeight}
                      />
                    );
                  })}
                {!moodlev2.currentModules && <SkeletonModules />}
              </ContentPickerContainer>
            </CourseContentContainer>
          </DetailCourseWrapper>
          <CustomDialog
            open={message.open}
            title={message.title}
            message={message.message}
            onCancel={() => setMessage({ ...message, open: false })}
            onConfirm={() => setMessage({ ...message, open: false })}
          />
        </>
      )}
    </>
  );
};

const SkeletonModules = () => {
  return (
    <>
      {[1, 2, 3, 4, 5].map((k, i) => {
        return <SkeletonModule key={i} />;
      })}
    </>
  );
};

const SkeletonModule = () => {
  return (
    <div
      style={{ display: "flex", padding: "1.2rem", alignItems: "center" }}
    >
      <Skeleton
        baseColor="var(--skeleton-base-color)"
        style={{
          opacity: 0.1,
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          marginRight: "1rem",
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <Skeleton
          baseColor="#adb5bd"
          style={{
            opacity: 0.1,
            width: "210px",
            height: "12px",
            marginLeft: "5px",
            borderRadius: "10px",
          }}
        />
        <Skeleton
          baseColor="#adb5bd"
          style={{
            opacity: 0.1,
            width: "210px",
            height: "12px",
            marginLeft: "5px",
            borderRadius: "10px",
          }}
        />
        <Skeleton
          baseColor="#adb5bd"
          style={{
            opacity: 0.1,
            width: "150px",
            height: "12px",
            marginLeft: "5px",
            borderRadius: "10px",
          }}
        />
      </div>
    </div>
  );
};

const DetailCourseWrapper = ({ children, token }) => {
  const theme = useTheme();
  return (
    <div
      className="detail-course-container"
      style={{
        backgroundColor: "var(--detail-course-bg)",
        height: "100dvh"
      }}
      id="course-wrapper"
    >
      <div
        className="row mx-0 "
        // style={{ height: "92dvh", maxHeight: "92dvh" }}
        style={{ height: "100%", maxHeight: "100%" }}
      >
        {children}
      </div>
    </div>
  );
};

const CoreVisualContent = ({
  moodlev2,
  token,
  layout,
  handleContentLayout,
  lang,
  setNavigating,
}) => {
  let embed = moodlev2.pageEmbed;
  let resourceContent = moodlev2.labelContent;

  const auth = useAuth();
  const { config } = useConfig()
  const frame = React.useRef(null);
  const { iframeLoaded, setIframeLoaded, iframeKey } = moodlev2;
  const theme = useTheme();
  const [isMobile, setIsMobile] = useState(false);
  // Ref para siempre tener la función de refresh actualizada (evita stale closure)
  const refreshCompletionRef = useRef(null);
  // Flag para saber si es la primera carga del iframe (no queremos refrescar en la carga inicial)
  const isFirstLoadRef = useRef(true);
  /*   const {config} = useConfig() */

  // Mantener el ref actualizado con la función más reciente del contexto
  useEffect(() => {
    refreshCompletionRef.current = moodlev2.refreshCompletionStatus;
  });

  // Resetear el flag de primera carga cuando cambia el recurso (iframeKey)
  useEffect(() => {
    isFirstLoadRef.current = true;
  }, [iframeKey]);

  useEffect(() => {
    const checkMobile = () => {
      const ua = navigator.userAgent;
      const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
      setIsMobile(iOS || (isSafari && /mobile/i.test(ua)));
    };
    checkMobile()
  }, [moodlev2])

  // POLLING: Sincronización automática Moodle -> Sidebar
  useEffect(() => {
    if (!moodlev2.currentResourceId) return;

    console.log("[completion] Iniciando polling de completado...");
    const interval = setInterval(() => {
      if (refreshCompletionRef.current) {
        refreshCompletionRef.current();
      }
    }, 10000); // Cada 10 segundos

    return () => {
      console.log("[completion] Deteniendo polling...");
      clearInterval(interval);
    };
  }, [moodlev2.currentResourceId]);

  const handleIframeLoad = () => {
    console.log("contenido cargado");
    setTimeout(() => {
      setIframeLoaded(true);
    }, 400);

    if (isFirstLoadRef.current) {
      // Es la carga inicial del recurso: ignorar el refresh
      isFirstLoadRef.current = false;
      return;
    }

    // Es una navegación posterior dentro del iframe (ej: envío de quiz, feedback, etc.)
    // Refrescar el estado de completado para actualizar los ticks
    console.log("[completion] Navegación detectada en iframe, refrescando estado...");
    const delay = setTimeout(() => {
      if (refreshCompletionRef.current) {
        refreshCompletionRef.current();
      }
    }, 2500);

    return () => clearTimeout(delay);
  };

  React.useEffect(() => {
    let refreshTrigger = localStorage.getItem("refresh");
    let newaccess = Number(localStorage.getItem("newaccess"));
    if (!refreshTrigger && newaccess) {
      let last = newaccess;
      let new_ = auth.user.id;
      let refresh = last === new_ ? false : true;
      if (refresh && frame.current !== null) {
        frame.current.addEventListener("load", () => {
          let url = window.location.pathname;
          localStorage.setItem("refresh", true);
          localStorage.removeItem("newaccess");
          window.location.replace(`${url}?watch=${new Date().getTime()}`);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frame]);

  /* Inicio codigo que recibe postMessage para poder cotejar si el iframe se encuentra en listado curso
   * el cual no debería estar visible
   */
  function transformURL(url) {
    // Escapar los caracteres especiales en la URL
    let escapedURL = url.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
    // Construir la expresión regular con la parte variable
    let regexString = escapedURL + "course\\/view\\.php\\?id=\\d+";
    // Crear la expresión regular
    let regex = new RegExp(regexString);
    return regex;
  }

  React.useEffect(() => {
    window.addEventListener("message", function (event) {
      let url = config.baseURL;
      let urlPattern = transformURL(url);
      // Verifica que el mensaje provenga del dominio esperado
      if (urlPattern.test(event.data.href)) {
        // redireccionar iframe a pagina 404
        frame.current.src = `${url}course/404.php`;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [embed]);
  /* Fin codigo recibir postMessaage */

  /* Inicio Image Embed code */

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
    renderToolbar: (Toolbar) => (
      <Toolbar></Toolbar>
    ),
  });

  const handleImgToken = (html, token) => {
    // Crear un elemento div para cargar el HTML como texto
    let src_token_with_param = `?token=${token}`;
    let src_token_without_param = `&token=${token}`;
    let div = document.createElement("div");
    div.innerHTML = html;

    // Obtener todas las etiquetas de imagen
    let imagenes = div.getElementsByTagName("img");

    // Recorrer todas las etiquetas de imagen y agregar el token al final del atributo src
    for (let i = 0; i < imagenes.length; i++) {
      let src = imagenes[i].getAttribute("src");
      if (src.includes("?")) {
        imagenes[i].setAttribute("src", src + src_token_without_param);
      } else {
        imagenes[i].setAttribute("src", src + src_token_with_param);
      }
    }

    // Devolver el HTML modificado
    return div.innerHTML;
  };

  /*   console.log(embed)
    console.log(moodlev2.currentResourceId)
    console.log(moodlev2.currentModules)
    console.log(module.availabilityinfo) */
  /* Nuevo caso, recurso no visible a menos que se cumpla una condicion: renderiza aviso de que recurso no está disponible hasta que se cumpla x condición. */
  if (embed && embed.endsWith(`id=${moodlev2.currentResourceId}`) && moodlev2.currentModules) {
    // Buscar en los arrays "modules" de "currentModules"
    for (const currentModule of moodlev2.currentModules) {
      const module = currentModule.modules.find(
        (mod) => mod.id === moodlev2.currentResourceId
      );
      console.log(module);
      if (module && module.uservisible === false) {
        // Si se encuentra el módulo, retornar availabilityinfo
        return (
          <div
            className={
              (layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html") + " flex flex-col h-full"
            }
            style={{
              position: "relative",
              transition: "0.5s",
              marginBottom: "4px",
            }}
          >
            <div
              className="flex-1 w-full"
              style={{
                color: readableColor(theme.colors.backgroundColorDetailCourse),
              }}
              dangerouslySetInnerHTML={{ __html: module.availabilityinfo }}
            ></div>

            <NavigationButtons
              layout={layout}
              lang={lang}
              setNavigating={setNavigating}
            />
          </div>
        );
      }
    }
  }

  if (embed && embed.includes("<img")) {
    let new_embed = handleImgToken(embed, token);

    return (
      <div
        className={(layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html") + " flex flex-col h-full"}
        style={{
          position: "relative",
          /* borderBottom: "2px solid #ccc", */
          transition: "0.5s",
          marginBottom: "4px",
        }}
      >
        <div
          ref={frame}
          className="flex-1 w-full"
          style={{
            width: "100%",
            overflow: "scroll",
            backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
          }}
          dangerouslySetInnerHTML={{ __html: new_embed }}
        ></div>
        <NavigationButtons
          layout={layout}
          lang={lang}
          setNavigating={setNavigating}
        />
      </div>
    );
  }

  if (/* isMobile &&  */embed && embed.toLowerCase().includes('.pdf')) {
    console.log('entra a mobile pdf')
    return (
      <div
        className={(layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html") + " flex flex-col h-full"}
        style={{
          position: "relative",
          transition: "0.1s",
        }}
      >
        {/* {!iframeLoaded && (
          <div className="absolute inset-0 bg-[#000] flex items-center justify-center z-10" style={{ transition: "background-color 0.1s ease", height: "90%" }}>
            <div
              className="size-16 border-[6px] border-gray-300 rounded-full animate-spin"
              style={{ borderTopColor: theme.mode === "light" ? theme.colors.button_light : theme.colors.button_dark }}
            ></div>
          </div>
        )} */}
        {/* <iframe
          key={iframeKey}
          ref={frame}
          id="iframePdf"
          type="application/pdf"
          scrolling="auto"
          src={`https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(embed)}&embedded=true`}
          width="100%"
          className="h-[100%]"
          frameBorder="0"
          title="pdf-viewer"
          onLoad={handleIframeLoad}
          style={{
            transition: "opacity 0.5s",
            marginBottom: "4px",
            opacity: iframeLoaded ? 1 : 0,
            backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
          }}
        /> */}

        <div className="flex-1 w-full overflow-hidden">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer fileUrl={embed} plugins={[defaultLayoutPluginInstance]} onDocumentLoad={handleIframeLoad} />
          </Worker>
        </div>

        <NavigationButtons layout={layout} lang={lang} setNavigating={setNavigating} />
      </div>
    );
  }

  /* Fin Image Embed */
  if (embed && !embed.startsWith("http")) {
    return (
      <div
        className={(layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html") + " flex flex-col h-full"}
        style={{
          position: "relative",
          /* borderBottom: "2px solid #ccc", */
          marginBottom: "4px",
          transition: "0.5s",
        }}
      >
        <div
          ref={frame}
          className="flex-1 w-full"
          style={{
            width: "100%",
            overflow: "scroll",
            backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
          }}
          dangerouslySetInnerHTML={{ __html: embed }}
        ></div>
        <NavigationButtons
          layout={layout}
          lang={lang}
          setNavigating={setNavigating}
        />
      </div>
    );
  }

  /* Inicio Label content */
  /*     if (resourceContent && !embed) {
        return (
          <div
            className={layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html"}
            style={{
              position: "relative",
              height: "100%",
              borderBottom: "2px solid #ccc",
              transition: "0.5s",
            }}
          >
            <div
              style={{
                maxHeight: "100%",
                width: "100%",
                overflow: "scroll",
              }}
              dangerouslySetInnerHTML={{ __html: resourceContent }}
            ></div>
            <NavigationButtons layout={layout} /> 
          </div>
        );
      } */


  return (
    <div
      className={(layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html") + " flex flex-col h-full"}
      style={{
        position: "relative",
        transition: "0.1s",
      }}
    >
      {!iframeLoaded && (
        <div className="absolute inset-0 bg-transparent flex items-center justify-center z-10" style={{ transition: "background-color 0.1s ease", height: "90%" }}>
          <div
            className="size-16 border-[6px] border-gray-300 rounded-full animate-spin"
            style={{ borderTopColor: theme.mode === "light" ? theme.colors.button_light : theme.colors.button_dark }}
          ></div>
        </div>
      )}
      <iframe
        key={iframeKey}
        ref={frame}
        src={embed}
        id="video-player"
        frameBorder="0"
        width="100%"
        allow="autoplay ; microphone; camera"
        className="flex-1 w-full"
        title="video"
        onLoad={handleIframeLoad}
        style={{
          /* borderBottom: "2px solid #ccc", */ transition: "opacity 0.5s",
          marginBottom: "4px",
          opacity: iframeLoaded ? 1 : 0,
          backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
        }}
      />
      <NavigationButtons
        layout={layout}
        lang={lang}
        setNavigating={setNavigating}
      />
    </div>
  );
};

const CourseContentContainer = ({ children, layout }) => {
  return (
    <div
      className={layout ? "col-xl-3" : "col-xl-0"}
      id="scrollable-modules-wrapper"
      style={{
        height: "calc(100% - 32px)",
        maxHeight: "100%",
        overflowY: "scroll",
        /* padding: "0.5rem", */
        /* paddingTop: "1rem", */
        /* borderLeft: "1px solid rgb(104, 183, 202)", */
        position: "relative",
        transition: "0.5s",
      }}
    >
      {children}
    </div>
  );
};

const DiagnosticEvaluationButton = () => {
  const moodlev2 = useMoodleV2();
  const [, /* isCompleted */ setCompleted] = useState(false);

  React.useEffect(() => {
    /* console.log(moodlev2.diagnostic); */
    if (moodlev2.diagnostic && moodlev2.diagnostic.length > 0) {
      let evaluation = moodlev2.diagnostic[0];
      let isCompleted = evaluation.completiondata?.state !== 0 || null;
      setCompleted(isCompleted);
    }
  }, [moodlev2.diagnostic]);

  /* console.log(moodlev2.diagnostic); */

  if (!moodlev2.diagnostic) {
    return null;
  }

  return (
    <button
      type="button"
      className="btn btn-primary btn-lg btn-block btn-evaluacion"
    >
      Realizar Evaluación Diagnóstica
    </button>
  );
};

const CourseTitle = ({ moodleV2, params }) => {
  const [title, setTitle] = useState("titulo");
  const theme = useTheme();
  const { user } = useAuth();

  useEffect(() => {
    if (moodleV2 && moodleV2.courses) {
      let course_title = moodleV2.courses.filter(
        (e) => e?.id === Number(params.id)
      );
      console.log(course_title);
      if (course_title[0]) {
        setTitle(course_title[0].displayname);
      } else {
        setTitle("");
      }
    }
    if (moodleV2 && !moodleV2.courses && user.id && user.token) {
      moodleV2.getCourses();
    }
    //eslint-disable-next-line
  }, [moodleV2?.courses, user]);

  return (
    <div
      className="mx-2 pt-1"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginBottom: "20px",
      }}
    >
      <h2
        className="font-jost font-semibold text-[22px] text-center"
        style={{
          color: theme.mode === "light" ? "var(--detail-course-title)" : "var(--detail-course-title-dark)",
        }}
      >
        {title}
      </h2>
    </div>
  );
};

const TabsRow = ({ lang }) => {
  const moodle = useMoodleV2();
  const { config } = useConfig();

  return (
    <div className="flex flex-row justify-center mb-2 gap-2 h-24">
      <button
        type="button"
        className={`${moodle.humhub ? "col-md-4 btn btn-primary btn-tab-course" : ""
          } detail-tab-button ${moodle.selectedView === 0 ? "is-active" : ""} font-medium text-2xl px-4 py-2 rounded-md hover:brightness-125 transition-all w-full h-full`}
        onClick={() => moodle.contentSelected()}
        style={{
          fontSize: "1.7rem",
          backgroundColor:
            moodle.selectedView === 0
              ? "var(--detail-tab-bg-active)"
              : "var(--detail-tab-bg-inactive)",
          color: moodle.selectedView === 0 ? "var(--text-on-brand-dark)" : "var(--text-on-brand-vibrant)",
          textDecoration: moodle.selectedView === 0 ? "underline" : "none",
        }}
      >
        {lang["Coursedetail"].content}
      </button>

      {config.opciones && config.opciones.includes("programa") && (
        <button
          type="button"
          className={`${moodle.humhub ? "col-md-6 btn btn-primary btn-tab-course" : ""
            } detail-tab-button ${moodle.selectedView === 1 ? "is-active" : ""} font-medium text-2xl px-4 py-2 rounded-md hover:brightness-125 transition-all w-full h-full`}
          onClick={() => moodle.programSelected()}
          style={{
            fontSize: "1.7rem",
            backgroundColor:
              moodle.selectedView === 1
                ? "var(--detail-tab-bg-active)"
                : "var(--detail-tab-bg-inactive)",
            color: moodle.selectedView === 1 ? "var(--text-on-brand-dark)" : "var(--text-on-brand-vibrant)",
            textDecoration: moodle.selectedView === 1 ? "underline" : "none",
          }}
        >
          Programa
        </button>
      )}

      {moodle.humhub && (
        <button
          type="button"
          className="detail-tab-button font-medium text-2xl px-4 py-2 rounded-md hover:brightness-125 transition-all w-full"
          onClick={() => moodle.humhubSelected()}
          style={{
            fontSize: "1.7rem",
            backgroundColor:
              moodle.selectedView === 2
                ? "var(--detail-tab-bg-active)"
                : "var(--detail-tab-bg-inactive)",
            color: moodle.selectedView === 2 ? "var(--text-on-brand-dark)" : "var(--text-on-brand-vibrant)",
            textDecoration: moodle.selectedView === 2 ? "underline" : "none",
          }}
        >
          {lang["Coursedetail"].forum}
        </button>
      )}

      <button
        type="button"
        className={`${moodle.humhub ? "col-md-4 btn btn-primary btn-tab-course" : ""
          } detail-tab-button ${moodle.selectedView === 2 ? "is-active" : ""} font-medium text-2xl px-4 py-2 rounded-md hover:brightness-125 transition-all w-full`}
        onClick={() => moodle.onlineSelected()}
        style={{
          fontSize: "1.7rem",
          backgroundColor:
            moodle.selectedView === 2
              ? "var(--detail-tab-bg-active)"
              : "var(--detail-tab-bg-inactive)",
          color: moodle.selectedView === 2 ? "var(--text-on-brand-dark)" : "var(--text-on-brand-vibrant)",
          textDecoration: moodle.selectedView === 2 ? "underline" : "none",
        }}
      >
        {lang["Coursedetail"].online_class}
      </button>
    </div>
  );
};

const GroupRow = ({ group }) => {
  return (
    <div className="row mx-0 group-row">
      <div className="group-text">
        <img className="group-icon" src={groupIcon} alt="group icon" />
        Grupo: {group}
      </div>
    </div>
  );
};

const ContentPickerContainer = ({ children }) => {
  return (
    <div
      className="content-container rounded-md"
      // className="content-container rounded-md !pb-8 laptop:!pb-[160px]"
      id="content-modules-container"
      style={{
        overflowY: "unset",
        height: "100%",
        // height: "calc(100% - 168px)",
        // paddingBottom: 160,
        scrollbarWidth: "thin",
        scrollbarColor: "#000 #333",
        "::-webkit-scrollbar": {
          width: "8px",
        },
        "::-webkit-scrollbar-track": {
          background: "#333",
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: "#000",
          borderRadius: "10px",
          border: "2px solid #333",
        },
        /* cursor: "pointer", */
      }}
    >
      {children}
    </div>
  );
};

const NavigationButtons = ({ layout, lang, setNavigating }) => {
  const theme = useTheme();
  const moodlev2 = useMoodleV2();
  const { iframeLoaded, setIframeLoaded } = moodlev2;
  const [btnText, setBtnText] = useState("");
  const [btnPrevText, setBtnPrevText] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const styles = {};

  styles.container = {};

  styles.prevButton = {
    borderRadius: isMobile ? "8px" : "30px",
    height: isMobile ? 42 : 50,
    width: "auto",
    maxWidth: isMobile ? "unset" : "45%",
    minWidth: isMobile ? "42px" : "180px",
    backgroundColor: moodlev2.prevResourceName
      ? "var(--detail-nav-btn-bg)"
      : "var(--detail-nav-btn-bg-disabled)",
    color: moodlev2.prevResourceName
      ? "var(--text-on-brand-vibrant)"
      : "var(--detail-nav-btn-text-disabled)",
    cursor: moodlev2.prevResourceName === null ? "default" : "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: isMobile ? "0 0.8rem" : "0.75rem 1.35rem",
    opacity: 1,
    pointerEvents: "auto",
    transition: "0.3s",
  };

  const isAtEnd = moodlev2.nextResourceName === "Fin del curso";

  styles.nextButton = {
    backgroundColor: isAtEnd
      ? "var(--detail-nav-btn-bg-disabled)"
      : "var(--detail-nav-btn-bg-alt)",
    color: isAtEnd
      ? "var(--detail-nav-btn-text-disabled)"
      : "var(--text-on-brand-dark)",
    height: isMobile ? 42 : 50,
    width: "auto",
    maxWidth: isMobile ? "55%" : "45%",
    minWidth: isMobile ? "unset" : "180px",
    padding: isMobile ? "0 0.8rem" : "0.75rem 1.35rem",
    borderRadius: isMobile ? "8px" : "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    cursor: isAtEnd ? "default" : "pointer",
    opacity: 1,
    pointerEvents: "auto",
    transition: "0.3s",
  };

  const prevBtnBg = moodlev2.prevResourceName
    ? (theme.mode === "light" ? theme.colors.button_light : theme.colors.button_dark) || "#0066D6"
    : "#EEEEEE";
  const nextBtnBg = isAtEnd
    ? "#EEEEEE"
    : (theme.mode === "light" ? theme.colors.primary_light : theme.colors.primary_dark) || "#122D4B";

  const prevArrowFilter = readableColor(prevBtnBg, "brightness(0)", "none", false);
  const nextArrowFilter = readableColor(nextBtnBg, "brightness(0)", "none", false);

  styles.arrowRightIcon = {
    transform: "translateY(1px)",
    width: 14,
    height: 14,
    objectFit: "contain",
    flexShrink: 0,
    opacity: isAtEnd ? 0.45 : 1,
    filter: nextArrowFilter,
  };

  styles.arrowLeftIcon = {
    width: 14,
    height: 14,
    objectFit: "contain",
    flexShrink: 0,
    transform: "rotate(180deg)",
    opacity: moodlev2.prevResourceName ? 1 : 0.45,
    filter: prevArrowFilter,
  };

  styles.contentTableButton = {
    backgroundColor: theme.colors.backgroundColorPrevBtn,
    color: "var(--text-on-brand-vibrant)",
    height: 42,
    borderRadius: 8,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: "1.2rem",
    pointerEvents: "auto",
  };

  const handleNext = async () => {
    if (isAtEnd) return;
    setNavigating((prev) => prev + 1);
    setIframeLoaded(false);
    await moodlev2.navigateNext();
  };

  const handlePrev = async () => {
    if (!moodlev2.prevResourceName) return;
    setNavigating((prev) => prev + 1);
    setIframeLoaded(false);
    await moodlev2.navigatePrev();
  };

  const handleNavButtonText = (dic, text) => {
    if (!text) return "";
    if (text === "Fin del curso") {
      return dic["Coursedetail"].finish_course;
    }
    // Eliminar prefijos para mostrar solo el nombre del módulo/recurso
    return text.replace("Siguiente Unidad: ", "").replace("Unidad Anterior: ", "");
  };

  useEffect(() => {
    setBtnText(handleNavButtonText(lang, moodlev2.nextResourceName));
    setBtnPrevText(handleNavButtonText(lang, moodlev2.prevResourceName));
    // Check if device is mobile
    const checkMobile = () => {
      const ua = navigator.userAgent;
      const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
      setIsMobile(iOS || isMobileDevice);
    };

    checkMobile();
    //eslint-disable-next-line
  }, [moodlev2.nextResourceName, moodlev2.prevResourceName]);

  const handleScrollToContent = () => {
    const contentContainer = document.querySelector('.content-container');
    if (contentContainer) {
      contentContainer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="w-full flex justify-between p-5 mt-auto z-10 pointer-events-none gap-2" style={styles.container}>
      <div className="flex gap-2">
        {isMobile && (
          <div
            className="hover:brightness-110 h-fit px-4"
            style={styles.contentTableButton}
            onClick={handleScrollToContent}
          >
            <p className="m-0 text-xl">Contenidos</p>
          </div>
        )}

        <div
          className={`detail-nav-button ${moodlev2.prevResourceName ? "is-enabled hover:brightness-110" : "is-disabled"}`}
          style={styles.prevButton}
          onClick={handlePrev}
        >
          <img src={flechaBlanca} alt="" aria-hidden="true" style={styles.arrowLeftIcon} />
          {!isMobile && (
            <p className="m-0 next-button text-[14px] laptop:text-[16px] font-medium line-clamp-2">{btnPrevText || "Unidad Anterior"}</p>
          )}
        </div>
      </div>

      <div
        className={`detail-nav-button ${!isAtEnd ? "is-enabled hover:brightness-110" : "is-disabled"}`}
        style={styles.nextButton}
        onClick={handleNext}
      >
        <p className="m-0 next-button text-[14px] laptop:text-[16px] font-medium truncate" style={{ maxWidth: isMobile ? "120px" : "100%" }}>
          {isMobile && btnText && btnText.length > 22 ? btnText.substring(0, 22) + "..." : btnText}
        </p>
        {isAtEnd ? (
          <></>
        ) : (
          <img src={flechaBlanca} alt="" aria-hidden="true" style={styles.arrowRightIcon} />
        )}
      </div>
    </div>
  );
};
